import { Amount, Text } from '@razorpay/blade/components';
import { usePayDetails } from 'components/PayDetails/context/PayDetailsContext';
import { AssignedFlexibleComponentsTableDataType } from 'components/PayDetails/types';
import { getPercentageValue, isFBPUnitAmount } from 'components/PayDetails/utils';
import React from 'react';

export const YearlyAmountColumn = ({
  rowData,
  monthlyDeclarationValue,
}: {
  rowData: AssignedFlexibleComponentsTableDataType;
  monthlyDeclarationValue: string;
}) => {
  const isAmount = isFBPUnitAmount(rowData.unit);
  const { compensationData } = usePayDetails();
  const {
    fixed: { totalYearlyAmount: totalYearlyFixedValue },
    variable: { totalYearlyAmount: totalYearlyVariableValue },
    otherCtc: { totalYearlyAmount: totalYearlyOtherCtcValue },
  } = compensationData.ctcBreakdownData;

  const totalAnnualCTC =
    totalYearlyFixedValue + totalYearlyOtherCtcValue + totalYearlyVariableValue;

  const basicComponent = compensationData.ctcBreakdownData.fixed.data.find(
    (component) => component.componentName.toLowerCase() === 'basic',
  );

  const totalBase = basicComponent ? basicComponent.perYearAmount : 0;

  const baseValue =
    rowData?.unit === 'PERCENTAGE_OF_CTC' || rowData?.unit === 'PERCENTAGE_OF_GROSS'
      ? totalAnnualCTC
      : rowData?.unit === 'PERCENTAGE_OF_BASIC'
      ? totalBase
      : '0';

  const amountToShow = isAmount
    ? Number(monthlyDeclarationValue) * 12
    : getPercentageValue(Number(baseValue), Number(monthlyDeclarationValue));
  return (
    <Text>
      <Amount value={amountToShow} />
    </Text>
  );
};
